import React from 'react';
import {handleClickShowProfileDropdown} from '../../client/helpers/LeftMenuHelper';
import {TRANSLATE_LOGOUT} from '../../translates/Translates';
import { path_tier3 } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';
import {logout} from '../../client/helpers/AuthHelper';

const UserProfileBox = () => {
    return(
        <div className="user-profile">
            <div className="profile-img">
                <img src={"/images/image.png"} alt="user" />
            </div>
            <div className="profile-text">
                <button type="button" className="dropdown-toggle profile-box-dropdown-toggle u-dropdown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" onClick={handleClickShowProfileDropdown}>Radoslav
                    Rychvalsky</button>
                <div className="dropdown-menu animated flipInY" id="profile-dropdown">
                    <Link to={path_tier3} className="dropdown-item">
                        <i className="ti-user"></i> My Profile</Link>
                    <Link to={path_tier3} className="dropdown-item">
                        <i className="ti-wallet"></i> My Balance</Link>
                    <Link to={path_tier3} className="dropdown-item">
                        <i className="ti-email"></i> Inbox</Link>
                    <div className="dropdown-divider"></div>
                    <Link to={path_tier3} className="dropdown-item">
                        <i className="fas fa-user-cog"></i> Account Setting</Link>
                    <div className="dropdown-divider"></div>
                    <button type="button" onClick={logout} className="link dropdown-item" data-toggle="tooltip" title="Logout">
                        <i className="fa fa-power-off"></i> {TRANSLATE_LOGOUT}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UserProfileBox;
